/**
 * CRA fige NODE_ENV=production sur `npm run build`, y compris en préprod.
 * On se fie donc à l’URL et/ou à REACT_APP_ENV (à poser au build préprod).
 */
export function isPreprodEnv() {
  if (process.env.REACT_APP_ENV === 'preprod') {
    return true;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  const host = window.location.hostname.toLowerCase();
  if (host.includes('preprod')) {
    return true;
  }

  const apiUrl = (process.env.REACT_APP_API_URL || '').toLowerCase();
  return apiUrl.includes('preprod');
}
